import React, { useState, useEffect } from 'react';
import api from '../../../../utils/api';
import { useNavigate, useLocation } from 'react-router-dom';

const Mobilisasi = () => {
  const navigate = useNavigate();
  const [profile, setProfile] = useState({});
  const [provinces, setProvinces] = useState([]);
  const [bandaraStasiun, setBandaraStasiun] = useState(['Bandar Udara Abdul Rachman Saleh', 'Bandar Udara Adisucipto', 'Bandar Udara Adisumarmo', 'Bandar Udara Ayawasi', 'Bandar Udara Banyuwangi', 'Bandar Udara Betoambari', 'Bandar Udara Binaka', 'Bandar Udara Cut Nyak Dhien', 'Bandar Udara Depati Amir', 'Bandar Udara Djalaluddin', 'Bandar Udara Domine Edward Osok', 'Bandar Udara El Tari', 'Bandar Udara Fatmawati Soekarno', 'Bandar Udara H.A.S. Hanandjoeddin', 'Bandar Udara Haji Muhammad Sidik', 'Bandar Udara Halim Perdanakusuma', 'Bandar Udara Haluoleo', 'Bandar Udara Hang Nadim', 'Bandar Udara Husein Sastranegara', 'Bandar Udara Iskandar', 'Bandar Udara Jalaluddin Gorontalo', 'Bandar Udara Jenderal Ahmad Yani', 'Bandar Udara Jos Orno Imsula', 'Bandar Udara Juanda', 'Bandar Udara Juwata', 'Bandar Udara Kalimarau', 'Bandar Udara Kuala Batee', 'Bandar Udara Kualanamu', 'Bandar Udara Lagaligo Bua', 'Bandar Udara Lombok Zainuddin Abdul Madjid', 'Bandar Udara Malikussaleh', 'Bandar Udara Minangkabau', 'Bandar Udara Mopah', 'Bandar Udara Mukomuko', 'Bandar Udara Mutiara SIS Al-Jufrie', 'Bandar Udara Ngurah Rai', 'Bandar Udara Palopo Lagaligo', 'Bandar Udara Pattimura', 'Bandar Udara Radin Inten II', 'Bandar Udara Rahadi Osman', 'Bandar Udara Raja Haji Fisabilillah', 'Bandar Udara Rendani', 'Bandar Udara Sam Ratulangi', 'Bandar Udara Sentani', 'Bandar Udara Silampari', 'Bandar Udara Silangit', 'Bandar Udara Soekarno–Hatta', 'Bandar Udara Soekarno–Hatta', 'Bandar Udara Sultan Aji Muhammad Sulaiman Sepinggan', 'Bandar Udara Sultan Hasanuddin', 'Bandar Udara Sultan Iskandar Muda', 'Bandar Udara Sultan Mahmud Badaruddin II', 'Bandar Udara Sultan Muhammad Kaharuddin III', 'Bandar Udara Sultan Muhammad Salahudin', 'Bandar Udara Sultan Syarif Kasim II', 'Bandar Udara Sultan Thaha', 'Bandar Udara Supadio', 'Bandar Udara Syamsuddin Noor', 'Bandar Udara Syukuran Aminuddin Amir', 'Bandar Udara Tampa Padang', 'Bandar Udara Tebelian', 'Bandar Udara Tjilik Riwut', 'Bandar Udara Wunopito Lewoleba', 'Bandar Udara Yogyakarta', 'Stasiun Babakan', 'Stasiun Babat', 'Stasiun Bandung', 'Stasiun Bangil', 'Stasiun Banjar', 'Stasiun Banyuwangi Kota', 'Stasiun Bekasi', 'Stasiun Blambanganumpu', 'Stasiun Blimbing', 'Stasiun Blitar', 'Stasiun Bogor', 'Stasiun Bogor Paledang', 'Stasiun Bojonegoro', 'Stasiun Brebes', 'Stasiun Bumiayu', 'Stasiun Cepu', 'Stasiun Cibadak', 'Stasiun Cibeber', 'Stasiun Cicalengka', 'Stasiun Cikampek', 'Stasiun Cikarang', 'Stasiun Cilacap', 'Stasiun Ciledug', 'Stasiun Cimahi', 'Stasiun Cirebon', 'Stasiun Cirebon Prujakan', 'Stasiun Cisaat', 'Stasiun Gambir', 'Stasiun Garut', 'Stasiun Gombong', 'Stasiun Gumilir', 'Stasiun Haurgeulis', 'Stasiun Jakarta Kota', 'Stasiun Jatibarang', 'Stasiun Jatinegara', 'Stasiun Jember', 'Stasiun Jombang', 'Stasiun Kalisetail', 'Stasiun Karawang', 'Stasiun Kebumen', 'Stasiun Kediri', 'Stasiun Kepanjen', 'Stasiun Kertapati', 'Stasiun Kertosono', 'Stasiun Ketanggungan', 'Stasiun Ketapang', 'Stasiun Kiaracondong', 'Stasiun Kisaran', 'Stasiun Klaten', 'Stasiun Klender', 'Stasiun Kradenan', 'Stasiun Kroya', 'Stasiun Kutoarjo', 'Stasiun Lamongan', 'Stasiun Lempuyangan', 'Stasiun Lubuk Linggau', 'Stasiun Madiun', 'Stasiun Magetan', 'Stasiun Malang', 'Stasiun Malang Kota Lama', 'Stasiun Manggarai', 'Stasiun Maos', 'Stasiun Medan', 'Stasiun Mojokerto', 'Stasiun Muara Enim', 'Stasiun Nganjuk', 'Stasiun Ngawi', 'Stasiun Papar', 'Stasiun Parungkuda', 'Stasiun Pasar Senen', 'Stasiun Pasuruan', 'Stasiun Pegadenbaru', 'Stasiun Pekalongan', 'Stasiun Pemalang', 'Stasiun Pondokranji', 'Stasiun Prabumulih', 'Stasiun Probolinggo', 'Stasiun Purwakarta', 'Stasiun Purwokerto', 'Stasiun Purwosari', 'Stasiun Rambipuji', 'Stasiun Rancaekek', 'Stasiun Rogojampi', 'Stasiun Semarang Poncol', 'Stasiun Semarang Tawang', 'Stasiun Serang', 'Stasiun Serpong', 'Stasiun Siantar', 'Stasiun Sidareja', 'Stasiun Sidoarjo', 'Stasiun Slawi', 'Stasiun Solobalapan', 'Stasiun Solojebres', 'Stasiun Sragen', 'Stasiun Sukabumi', 'Stasiun Surabaya Gubeng', 'Stasiun Surabaya Pasar Turi', 'Stasiun Tanah Abang', 'Stasiun Tanggul', 'Stasiun Tanjungkarang', 'Stasiun Tasikmalaya', 'Stasiun Tegal', 'Stasiun Terisi', 'Stasiun Tulungagung', 'Stasiun Waru', 'Stasiun Wates', 'Stasiun Weleri', 'Stasiun Wlingi', 'Stasiun Wonokromo', 'Stasiun Yogyakarta', 'Stasiun Yogyakarta International Airport', 'Bandar Udara Tana Toraja', 'Bandar Udara Ranai', 'Bandar Udara Frans Kaisiepo', 'Bandar Udara Soekarno-Hatta', 'Stasiun Ciamis', 'Bandar Udara Aji Pangeran Tumenggung Pranoto', 'Bandar Udara Sangia Nibandera Kolaka', 'Bandar Udara Muara Bungo', 'Bandar Udara Karel Sadsuitubun Langgur', 'Bandar Udara Nabire', 'Bandar Udara Waingapu', 'Bandar Udara Sultan Babullah', 'Stasiun Batang', 'Stasiun Randublatung', 'Bandar Udara H. Asan Sampit', 'Stasiun Klakah', 'Stasiun Kras', 'Stasiun Randublatung', 'Stasiun Lawang', 'Bandar Udara Frans Seda', 'Stasiun Purworejo', 'Stasiun Cipeundeuy', 'Stasiun Ngrombo', 'Bandar Udara Komodo', 'Bandar Udara Umbu Mehang Kunda', 'Stasiun Jeruklegi', 'Bandar Udara Internasional Mopah', 'Bandar Udara Malinau Robert Atty Bessing', 'Bandar Udara Dr. Ferdinand Lumban Tobing (Pinangsori)', 'Bandar Udara Wamena', 'Bandar Udara Pangsuma', 'Stasiun Puluraja', 'Bandar Udara Wamena', 'Bandar Udara Wamena', 'Bandar Udara Gusti Syamsir Alam', 'Bandar Udara Mozes Kilangin Timika', 'Bandar Udara Kertajati']);
  const location = useLocation();
  const { user } = location.state;

  useEffect(() => {
    setProfile(user);
    const getProvinces = async () => {
      const provinces = await api.getProvincies();
      setProvinces(provinces)
    }

    if (user?.mob_keb_pengajuan_keberangkatan === "Mengajukan Keberangkatan") {
      setMob_keb_pengajuan(false);
    } else {
      setMob_keb_pengajuan(true);
    }

    if (user?.mob_kep_pengajuan_kepulangan === "Mengajukan Kepulangan") {
      setMob_kep_pengajuan(false);
    } else {
      setMob_kep_pengajuan(true);
    }

    getProvinces();
  }, []);

  const [keb_prov_asal_keb, setKeb_prov_asal_keb] = useState('');
  const [isChecked_keb_prov_asal_keb, setIsChecked_keb_prov_asal_keb] = useState(true)
  const onHandleSave_keb_prov_asal_keb = () => {
    setProfile({ ...profile, mob_keb_provinsi_asal_keberangkatan: keb_prov_asal_keb })
    setIsChecked_keb_prov_asal_keb(!isChecked_keb_prov_asal_keb);
  }

  const [kep_prov_asal_keb, setKep_prov_asal_keb] = useState('');
  const [isChecked_kep_prov_asal_keb, setIsChecked_kep_prov_asal_keb] = useState(true)
  const onHandleSave_kep_prov_asal_keb = () => {
    setProfile({ ...profile, mob_kep_provinsi_asal_keberangkatan: kep_prov_asal_keb })
    setIsChecked_kep_prov_asal_keb(!isChecked_kep_prov_asal_keb);
  }

  const [mob_keb_pengajuan, setMob_keb_pengajuan] = useState(true);
  const onHandle_mob_keb_pengajuan_keberangkatan = (e) => {
    const { value } = e.target;
    setProfile({ ...profile, mob_keb_pengajuan_keberangkatan: value })
    if (value === "Mengajukan Keberangkatan") {
      setMob_keb_pengajuan(false)
    } else if (value === "Tidak Mengajukan Keberangkatan") {
      setMob_keb_pengajuan(true)
    }
  }

  const [mob_kep_pengajuan, setMob_kep_pengajuan] = useState(true);
  const onHandle_mop_keb_pengajuan_kepulangan = (e) => {
    const { value } = e.target;
    setProfile({ ...profile, mob_kep_pengajuan_kepulangan: value })
    if (value === "Mengajukan Kepulangan") {
      setMob_kep_pengajuan(false)
    } else if (value === "Tidak Mengajukan Kepulangan") {
      setMob_kep_pengajuan(true)
    }
  }

  const [disableUpload, setDisableUpload] = useState(false);


  const onHandleSubmit = () => {
    // const assingn = Object.assign(updateUser, profile);
    const assign = {
      ...user, ...profile
    }
    navigate('/app/profile/update/interest-talent', { state: { user: assign } })
  }

  return (
    <>
      <div className="py-5 text-center">
        <h2>II. MOBILISASI KEBERANGKATAN DAN KEPULANGAN</h2>
        <p className="lead">Bagian ini hanya perlu diisi Mahasiswa Magang MSIB Kemendikbud Ristek yang mengajukan tiket keberangkatan dan kepulangan dari daerah domisili ke daerah penempatan Magang.
          Selain mahasiswa Magang MSIB, atau mahasiswa yang tidak akan mengajukan mobilisasi silakan melewati bagian ini
          Tiket akan dibelikan oleh Tim MSIB Kemendikbud Ristek dan hanya bisa moda pesawat atau kereta api saja, yaitu satu kali transportasi berangkat dan satu kali transportasi pulang (tidak termasuk biaya atau tiket menuju bandara/stasiun maupun dari bandara/stasiun ke lokasi penempatan Magang.
          Tiket sudah termasuk mengakomodir transit pesawat.
          Provinsi keberangkatan dan kepulangan harus sesuai dengan provinsi di KTP atau Universitas (bisa berangkat dari rumah sesuai alamat di KTP atau dari domisili kampus saja).
          Tiket harus digunakan dan jika tidak digunakan maka mahasiswa harus mengembalikan uang dengan besaran pembelian tiket pada MSIB Kemendikbud Ristek.
          Jika mahasiswa terlambat atau terdapat kondisi yang membuat tiket tidak digunakan, selain harus mengganti uang tiket, mahasiswa juga harus membeli tiket kembali dengan biaya pribadi untuk berangkat atau pulang.</p>
      </div>

      <div className="row g-5">

        <div className="col-md-12 col-lg-8">
          <form className="needs-validation mb-5" noValidate="">
            <div className="row g-3">

              <div className="card">
                <div className="card-body">

                  <div class="alert alert-primary d-flex align-items-center" role="alert">
                    <div>
                      Tidak Perlu diisi jika tidak melakukan mobilisasi keberangkatan atau kepulangan!
                    </div>
                  </div>

                  <h4 className="mb-3">Keberangkatan</h4>
                  <p>Mobilisasi keberangkatan dilakukan di awal Bulan Maret/September (sesuai periode semester penyelenggaraan Magang)</p>

                  <div className="row g-3">
                    <div className="col-12">
                      <label htmlFor="country" className="form-label">Pengajuan Mobilisasi Keberangkatan</label>
                      <select value={profile?.mob_keb_pengajuan_keberangkatan} onChange={(e) => onHandle_mob_keb_pengajuan_keberangkatan(e)} className="form-select" id="country" required="">
                        <option defaultValue>Pilih Pengajuan Mobilisasi Keberangkatan</option>
                        <option value="Mengajukan Keberangkatan">Mengajukan Keberangkatan</option>
                        <option value="Tidak Mengajukan Keberangkatan">Tidak Mengajukan Keberangkatan</option>
                      </select>
                    </div>

                    {!mob_keb_pengajuan &&
                      <>
                        <div className="col-12">
                          <label htmlFor="country" className="form-label">Provinsi keberangkatan</label>
                          <select disabled={mob_keb_pengajuan} value={profile?.mob_keb_provinsi_keberangkatan} onChange={(e) => setProfile({ ...profile, mob_keb_provinsi_keberangkatan: e.target.value })} className="form-select" required="">
                            <option defaultValue>Pilih Provinsi keberangkatan</option>
                            {provinces?.map((value, key) => (
                              <option key={key} id={value.provinceId} value={value.provinceName}>{value.provinceName}</option>
                            ))}
                          </select>
                        </div>

                        <div className="col-12">
                          <label htmlFor="country" className="form-label">Moda Keberangkatan</label>
                          <select disabled={mob_keb_pengajuan} value={profile?.mob_keb_moda_keberangkatan} onChange={(e) => setProfile({ ...profile, mob_keb_moda_keberangkatan: e.target.value })} className="form-select" id="country" required="">
                            <option defaultValue>Pilih Moda Keberangkatan</option>
                            <option value="Kereta Api">Kereta Api</option>
                            <option value="Pesawat">Pesawat</option>
                          </select>
                        </div>

                        <div className="col-12">
                          <label htmlFor="country" className="form-label">Domisili Provinsi Asal Keberangkatan</label>

                          <div className="form-check">
                            <input disabled={mob_keb_pengajuan} value="Domisili KTP" onChange={(e) => setProfile({ ...profile, mob_keb_provinsi_asal_keberangkatan: e.target.value })} className="form-check-input" type="radio" name="kebRadio" id="kebRadio1" />
                            <label className="form-check-label" htmlFor="flexRadioDefault1">
                              Domisili KTP
                            </label>
                          </div>
                          <div className="form-check">
                            <input disabled={mob_keb_pengajuan} value="Domisili Perguruan Tinggi" onChange={(e) => setProfile({ ...profile, mob_keb_provinsi_asal_keberangkatan: e.target.value })} className="form-check-input" type="radio" name="kebRadio" id="kebRadio2" />
                            <label className="form-check-label" htmlFor="flexRadioDefault2">
                              Domisili Perguruan Tinggi
                            </label>
                          </div>
                          <div className="form-check">
                            <input disabled={mob_keb_pengajuan} value="Lainnya" onChange={(e) => setProfile({ ...profile, mob_keb_provinsi_asal_keberangkatan: e.target.value })} className="form-check-input" type="radio" name="kebRadio" id="kebRadio3" />
                            <label className="form-check-label" htmlFor="flexRadioDefault3">
                              Lainnya
                            </label>
                          </div>
                          {/* <div className="input-group mt-2">
                            <div className="input-group-text">
                              <input disabled={mob_keb_pengajuan} value={keb_prov_asal_keb} onChange={() => setIsChecked_keb_prov_asal_keb(!isChecked_keb_prov_asal_keb)} className="form-check-input mt-0" type="radio" aria-label="Checkbox for following text input" name="kebRadio" id="kebRadio3" />
                            </div>
                            <input disabled={isChecked_keb_prov_asal_keb} onChange={(e) => setKeb_prov_asal_keb(e.target.value)} type="text" placeholder='Lainnya' className="form-control" aria-describedby="button-addon2" aria-label="Text input with checkbox" />
                            <button disabled={isChecked_keb_prov_asal_keb} onClick={() => onHandleSave_keb_prov_asal_keb()} className="btn btn-outline-secondary" type="button" id="button-addon2">Simpan</button>
                          </div> */}
                        </div>

                        <div className="col-12">
                          <label htmlFor="country" className="form-label">Bandara / Stasiun Keberangkatan</label>
                          <select disabled={mob_keb_pengajuan} value={profile?.mob_keb_bandara_stasiun_keberangkatan} onChange={(e) => setProfile({ ...profile, mob_keb_bandara_stasiun_keberangkatan: e.target.value })} className="form-select" required="">
                            <option defaultValue>Pilih Bandara / Stasiun Keberangkatan</option>
                            {bandaraStasiun.map((bandara, key) => (
                              <option key={key} value={bandara}>{bandara}</option>
                            ))}
                          </select>
                        </div>

                        <div className="col-12">
                          <label htmlFor="country" className="form-label">Provinsi Bandara / Stasiun Keberangkatan</label>
                          <select disabled={mob_keb_pengajuan} value={profile?.mob_keb_prov_bandara_stasiun_keberangkatan} onChange={(e) => setProfile({ ...profile, mob_keb_prov_bandara_stasiun_keberangkatan: e.target.value })} className="form-select" required="">
                            <option defaultValue>Pilih Provinsi Bandara / Stasiun Keberangkatan</option>
                            {provinces?.map((value, key) => (
                              <option key={key} id={value.provinceId} value={value.provinceName}>{value.provinceName}</option>
                            ))}
                          </select>
                        </div>

                        <div className="col-12">
                          <label htmlFor="country" className="form-label">Bandara / Stasiun Tujuan</label>
                          <select disabled={mob_keb_pengajuan} value={profile?.mob_keb_bandara_stasiun_tujuan} onChange={(e) => setProfile({ ...profile, mob_keb_bandara_stasiun_tujuan: e.target.value })} className="form-select" required="">
                            <option defaultValue>Pilih Bandara / Stasiun Tujuan</option>
                            {bandaraStasiun.map((bandara, key) => (
                              <option key={key} value={bandara}>{bandara}</option>
                            ))}
                          </select>
                        </div>

                        <div className="col-12">
                          <label htmlFor="country" className="form-label">Provinsi Bandara / Stasiun Tujuan</label>
                          <select disabled={mob_keb_pengajuan} value={profile?.mob_keb_prov_bandara_stasiun_tujuan} onChange={(e) => setProfile({ ...profile, mob_keb_prov_bandara_stasiun_tujuan: e.target.value })} className="form-select" required="">
                            <option defaultValue>Pilih Provinsi Bandara / Stasiun Tujuan</option>
                            {provinces?.map((value, key) => (
                              <option key={key} id={value.provinceId} value={value.provinceName}>{value.provinceName}</option>
                            ))}
                          </select>
                        </div>
                      </>
                    }


                  </div>

                </div>
              </div>

              <div className="card">
                <div className="card-body">
                  <h5 className="mb-3">Kepulangan</h5>
                  <p>Mobilisasi kepulangan di akhir peiode Magang yaitu minggu terakhir Bulan Juni/Desember (sesuai semester penyelenggaraan Magang)</p>

                  <div className="row g-3">
                    <div className="col-12">
                      <label htmlFor="country" className="form-label">Pengajuan Mobilisasi Kepulangan</label>
                      <select value={profile?.mob_kep_pengajuan_kepulangan} onChange={(e) => onHandle_mop_keb_pengajuan_kepulangan(e)} className="form-select" id="country" required="">
                        <option defaultValue>Pilih Pengajuan Mobilisasi Kepulangan</option>
                        <option value="Mengajukan Kepulangan">Mengajukan Kepulangan</option>
                        <option value="Tidak Mengajukan Kepulangan">Tidak Mengajukan Kepulangan</option>
                      </select>
                    </div>

                    {!mob_kep_pengajuan &&
                      <>
                        <div className="col-12">
                          <label htmlFor="country" className="form-label">Provinsi Kepulangan</label>
                          <select disabled={mob_kep_pengajuan} value={profile?.mob_kep_provinsi_kepulangan} onChange={(e) => setProfile({ ...profile, mob_kep_provinsi_kepulangan: e.target.value })} className="form-select" required="">
                            <option defaultValue>Pilih Provinsi Kepulangan</option>
                            {provinces?.map((value, key) => (
                              <option key={key} id={value.provinceId} value={value.provinceName}>{value.provinceName}</option>
                            ))}
                          </select>
                        </div>

                        <div className="col-12">
                          <label htmlFor="country" className="form-label">Moda Kepulangan</label>
                          <select disabled={mob_kep_pengajuan} value={profile?.mob_kep_moda_kepulangan} onChange={(e) => setProfile({ ...profile, mob_kep_moda_kepulangan: e.target.value })} className="form-select" id="country" required="">
                            <option defaultValue>Pilih Moda Kepulangan</option>
                            <option value="Kereta Api">Kereta Api</option>
                            <option value="Pesawat">Pesawat</option>
                          </select>
                        </div>

                        <div className="col-12">
                          <label htmlFor="country" className="form-label">Domisili Provinsi Asal Keberangkatan (Menuju Lokasi Pulang)</label>

                          <div className="form-check">
                            <input disabled={mob_kep_pengajuan} value="Domisili KTP" onChange={(e) => setProfile({ ...profile, mob_kep_provinsi_asal_keberangkatan: e.target.value })} className="form-check-input" type="radio" name="kepRadio" id="kepRadio1" />
                            <label className="form-check-label" htmlFor="flexRadioDefault1">
                              Domisili KTP
                            </label>
                          </div>
                          <div className="form-check">
                            <input disabled={mob_kep_pengajuan} value="Domisili Perguruan Tinggi" onChange={(e) => setProfile({ ...profile, mob_kep_provinsi_asal_keberangkatan: e.target.value })} className="form-check-input" type="radio" name="kepRadio" id="kepRadio2" />
                            <label className="form-check-label" htmlFor="flexRadioDefault2">
                              Domisili Perguruan Tinggi
                            </label>
                          </div>
                          <div className="form-check">
                            <input disabled={mob_kep_pengajuan} value="Lainnya" onChange={(e) => setProfile({ ...profile, mob_kep_provinsi_asal_keberangkatan: e.target.value })} className="form-check-input" type="radio" name="kepRadio" id="kepRadio3" />
                            <label className="form-check-label" htmlFor="flexRadioDefault3">
                              Lainnya
                            </label>
                          </div>
                          {/* <div className="input-group mt-2">
                            <div className="input-group-text">
                              <input disabled={mob_kep_pengajuan} value={kep_prov_asal_keb} onChange={() => setIsChecked_kep_prov_asal_keb(!isChecked_kep_prov_asal_keb)} className="form-check-input mt-0" type="radio" aria-label="Checkbox for following text input" name="kepRadio" id="kepRadio3" />
                            </div>
                            <input disabled={isChecked_kep_prov_asal_keb} value={kep_prov_asal_keb} onChange={(e) => setKep_prov_asal_keb(e.target.value)} type="text" placeholder='Lainnya' className="form-control" aria-describedby="button-addon2" aria-label="Text input with checkbox" />
                            <button disabled={isChecked_kep_prov_asal_keb} onClick={() => onHandleSave_kep_prov_asal_keb()} className="btn btn-outline-secondary" type="button" id="button-addon2">Simpan</button>
                          </div> */}
                        </div>

                        <div className="col-12">
                          <label htmlFor="country" className="form-label">Bandara / Stasiun Kepulangan</label>
                          <select disabled={mob_kep_pengajuan} value={profile?.mob_kep_bandara_stasiun_kepulangan} onChange={(e) => setProfile({ ...profile, mob_kep_bandara_stasiun_kepulangan: e.target.value })} className="form-select" required="">
                            <option defaultValue>Pilih Bandara / Stasiun Kepulangan</option>
                            {bandaraStasiun.map((bandara, key) => (
                              <option key={key} value={bandara}>{bandara}</option>
                            ))}
                          </select>
                        </div>

                        <div className="col-12">
                          <label htmlFor="country" className="form-label">Provinsi Bandara / Stasiun Kepulangan</label>
                          <select disabled={mob_kep_pengajuan} value={profile?.mob_kep_prov_bandara_stasiun_kepulangan} onChange={(e) => setProfile({ ...profile, mob_kep_prov_bandara_stasiun_kepulangan: e.target.value })} className="form-select" required="">
                            <option defaultValue>Pilih Provinsi Bandara / Stasiun Kepulangan</option>
                            {provinces?.map((value, key) => (
                              <option key={key} id={value.provinceId} value={value.provinceName}>{value.provinceName}</option>
                            ))}
                          </select>
                        </div>

                        <div className="col-12">
                          <label htmlFor="country" className="form-label">Bandara / Stasiun Tujuan</label>
                          <select disabled={mob_kep_pengajuan} value={profile?.mob_kep_bandara_stasiun_tujuan} onChange={(e) => setProfile({ ...profile, mob_kep_bandara_stasiun_tujuan: e.target.value })} className="form-select" required="">
                            <option defaultValue>Pilih Bandara / Stasiun Tujuan</option>
                            {bandaraStasiun.map((bandara, key) => (
                              <option key={key} value={bandara}>{bandara}</option>
                            ))}
                          </select>
                        </div>

                        <div className="col-12">
                          <label htmlFor="country" className="form-label">Provinsi Bandara / Stasiun Tujuan</label>
                          <select disabled={mob_kep_pengajuan} value={profile?.mob_kep_prov_bandara_stasiun_tujuan} onChange={(e) => setProfile({ ...profile, mob_kep_prov_bandara_stasiun_tujuan: e.target.value })} className="form-select" required="">
                            <option defaultValue>Pilih Provinsi Bandara / Stasiun </option>
                            {provinces?.map((value, key) => (
                              <option key={key} id={value.provinceId} value={value.provinceName}>{value.provinceName}</option>
                            ))}
                          </select>
                        </div>
                      </>
                    }

                  </div>

                </div>
              </div>

              <div className="card">
                <div className="card-body">
                  <div className="col-12">
                    <p>
                      Bagi mahasiswa yang berangkat atau tujuan pulangnya bukan dari domisili alamat di KTP atau bukan dari domisili perguruan tinggi, maka harus melampirkan surat pernyataan yang dibuat sendiri berisi identitas diri dan alasan/urgensi perbedaan lokasi keberangkatan/kepulangan dengan TTD mahasiswa
                    </p>
                    <p>
                      Contoh: Mahasiswa dari universitas di Provinsi DKI Jakarta dapat memilih bandara Halim Perdanakusuma atau Bandara Soekarno Hatta.
                    </p>
                    <p>
                      Bandara Soekarno Hatta berada di Provinsi Banten, maka surat keterangan alasannya bisa karena bandara terdekat adalah Bandara Soekarno Hatta
                    </p>
                    <label htmlFor="country" className="form-label">Upload Surat Keterangan (Google Drive Link)</label>
                    <input disabled={disableUpload} onChange={(e) => setProfile({ ...profile, mob_url_surat_keterangan: e.target.value })} value={profile?.mob_url_surat_keterangan} type="text" className="form-control" id="address" required="" />
                  </div>
                </div>
              </div>

            </div>

            <button onClick={() => onHandleSubmit()} className="w-100 btn btn-primary btn-lg my-4" type="button">Lanjut</button>
          </form>
        </div >
      </div >
    </>
  )
}

export default Mobilisasi